import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        amount: 0,
        insert: 0
    },
    actions: {
        addInvoice({commit}, value) {
            commit('ADD_INVOICE', value)
        },
        addCash({commit}, value) {
            commit('ADD_CASH', value)
        },
        clearCache({commit}){
            commit('CLEAR_CACHE')
        }
    },
    mutations: {
        ADD_INVOICE(state, value) {
            state.amount = value
        },
        ADD_CASH(state, value) {
            state.insert += value
        },
        CLEAR_CACHE(state){
            state.amount = 0;
            state.insert = 0;
        }
    },
    getters: {
        change(state) {
            var change = state.insert - state.amount;
            return change<0?0:change;
        }
    }
})

export default store


// WEBPACK FOOTER //
// ./vue-source/src/common/js/store.js